module.exports = __webpack_public_path__ + "img/next3.f8877fc2.svg";